import { useMemo } from "react";

import { Button } from "@/components/ui/button/button";

type Props = {
	inSale: boolean;
	isValid: boolean;

	onPublish: () => void;
};

export const CommonHeaderPublishButton = ({ isValid, inSale, onPublish }: Props) => {
	const buttonText = useMemo(() => {
		return "保存して公開（ゲストへメール送信）";
	}, []);

	const shouldShow = useMemo(() => {
		return !inSale;
	}, [inSale]);

	return (
		shouldShow && (
			<Button variant={isValid ? "default" : "disabled"} size={"xl"} onClick={onPublish}>
				{buttonText}
			</Button>
		)
	);
};

CommonHeaderPublishButton.displayName = "CommonHeaderPublishButton";
